import { render } from "./Cardlist.vue?vue&type=template&id=84de3cd2&scoped=true"
import script from "./Cardlist.vue?vue&type=script&lang=js"
export * from "./Cardlist.vue?vue&type=script&lang=js"

import "./Cardlist.vue?vue&type=style&index=0&id=84de3cd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\H2001566\\Documents\\Projekte\\Diversity Quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84de3cd2"]])

export default __exports__